<div>
  <div class="card mt-3 card_outLine">
    <div class="card-body">
      <h5 class="title_five">Edit template - {{templateName}}</h5>
      <div class="row">
        <div class="col-lg-4 col-sm-4 col-md-4" style="height: 45rem; overflow-y: scroll;">
          <form [formGroup]="templateDataForm">
            <div formArrayName="fieldDataForms">
              <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6 mt-2"
                  *ngFor="let field of fieldDataForms().controls; let i = index">
                  <div [formGroupName]="i">
                    <div *ngIf="field.value.validators['required']">
                      <span class="form_field">{{ field.value.label_attribute }} </span><span class="color_red">*</span>
                      <div  class="flex_row custom-input">
                        <input [type]="field.value.html_tag" pInputText [formControlName]="'value_attribute'"
                          (ngModelChange)="onInputChange($event,field.value)" [placeholder]="field.value.label_attribute"
                          [required]="field.value.validators['required']"
                          (focus)="onFieldFocus(field.value)"
                          (click)="onFieldFocus(field.value)"
                          (keypress)="onKeyPress($event,field.value.validators['pattern'])"
                          (paste)="onPaste($event, field.value.validators['pattern'])"
                          >
                          
                        <span class="p-error" style="font-size: 0.5rem;"
                          *ngIf="submitted && fieldDataForms().at(i).get('value_attribute')?.hasError('required')">Enter
                          required value</span>
                      </div>
                    </div>
                    <div *ngIf="!field.value.validators['required']">
                      <span class="form_field">{{ field.value.label_attribute }} </span>
                      <div  class="flex_row custom-input inputdirty">
                        <input [type]="field.value.html_tag"  pInputText [formControlName]="'value_attribute'"
                          (ngModelChange)="onInputChange($event,field.value)" [placeholder]="field.value.label_attribute"
                          [required]="field.value.validators['required']"
                          (focus)="onFieldFocus(field.value)"
                          (click)="onFieldFocus(field.value)"
                          (keypress)="onKeyPress($event,field.value.validators['pattern'])"
                          (paste)="onPaste($event, field.value.validators['pattern'])">
                      </div>
                    </div>
                    
                  
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-lg-7 col-sm-7 col-md-7 iframe_border">
          <iframe #myIframe [srcdoc]="htmlData | safeHtml" class="col-md-12 text-center this-is-iframe"
            style="height: 47rem; border-width: thin; background-color: #ffffff; transform: scale(1); transform-origin: top;"></iframe>

        </div>
      </div>
      <div class="flex_row">
        <div class="col-lg-1 col-sm-1 col-md-1">
          <div class="text-left custom_button m-2">
            <p-button label="Back" (click)="backToProductDetails()" styleClass="p-button-sm-outline"></p-button>
          </div>
        </div>
        <div class="col-lg-9 col-sm-9 col-md-9"></div>
        <div class="col-lg-1 col-sm-1 col-md-1">
          <div class="text-right custom_button m-2">
            <p-button label="Preview" (click)="reviewData(reviewDataPage)" styleClass="p-button-sm-outline"></p-button>
          </div>
        </div>
        <div class="col-lg-1 col-sm-1 col-md-1">
          <div class="text-right custom_button m-2">
            <p-button label="Next" (click)="nextStepEstamp()" styleClass="p-button-sm-outline"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #reviewDataPage let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title"> Review Entered Data </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 50rem; overflow: scroll;">
    <div *ngIf="isLoadingPdf" class="d-flex flex-column align-items-center justify-content-center" style="height: 100%;">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p class="mt-2">Loading preview...</p>
    </div>
    <div *ngIf="!isLoadingPdf" class="row m-2 table_styleing">
      <pdf-viewer [src]="pdfSource" [render-text]="true" [original-size]="false"
        style="width: 100%; height: 45rem;"></pdf-viewer>
    </div>
  </div>
</ng-template>